import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { ModalBaseComponent } from '../add-or-edit-org-modal/modal-base.component';
import { StudentQRCode } from '../data/student-qr-code';
import { QRCodeComponent } from 'angularx-qrcode';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataService } from '../data/data.service';

@Component({
  selector: 'app-student-qr-modal',
  templateUrl: './student-qr-modal.component.html',
  styleUrls: ['./student-qr-modal.component.css']
})
export class StudentQrModalComponent extends ModalBaseComponent<StudentQRCode> implements OnInit {
  @Input() StudentID: number;
  @ViewChild('qrCodeContainer', { static: false }) qrCode: any;

  constructor(modalService: NgbModal, dataService: DataService) 
  { 
    super(modalService, dataService);
  }

  open(content) {
    var modalRef = this.modalService.open(content, {
      ariaLabelledBy: 'modal-basic-title',
      size: "sm",
      windowClass: 'custom-class'
    });

    this.modal = modalRef;

    modalRef.result.then((result) => {
      this.initializeNewData();
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.initializeNewData();
      this.closeResult = `Dismissed ${reason.toString()}`;
    });
  }
  
  initializeNewData(): void {
    this.dataService.getStudentQRCode(this.StudentID).subscribe(s => {
      this.data = s;
    });
  }
  isInputValid(): boolean {
    return true;
  }
  saveEdit(): void {
    throw new Error('Method not implemented.');
  }
  saveNew(): void {
    throw new Error('Method not implemented.');
  }

  ngOnInit() {
    this.initializeNewData();
  }

}
